import { IVehicleFullColumnSort } from "../interfaces/vehicle.interface";
import { LOCAL_STORAGE_VAR } from "./localstorage";

export function getConfigSavedListSortColumns(): IVehicleFullColumnSort[] {
    try {
      return JSON.parse(localStorage.getItem(LOCAL_STORAGE_VAR.VEHICLE_FULL_LIST_SORT_COLUMNS_CONFIG) as string) || []; 
    }
    catch (_) {
      return [];
    }
}